import { schema } from 'normalizr';
import { SCHEMA_TYPE_DOMAINS } from 'js/constants/schemaTypes';

const domainSchema = new schema.Entity(SCHEMA_TYPE_DOMAINS);

export default domainSchema;
